<div *transloco="let t; read: 'project-sentiment-range'" class="project-sentiment-range__container">
  <div class="project-sentiment-range__content">
    <div class="project-sentiment-range__dropdown">
      <xi-dropdown
        [placeholder]="t('point-scale')"
        select="single"
        [value]="'' + sentimentScale"
        [data]="projectSentimentScaleDropdown"
        (onValueChange)="sentimentScale = +$event.detail.selected.id"
      ></xi-dropdown>
    </div>

    <hr />

    <div
      [ngClass]="
        sentimentScale === 3
          ? 'project-sentiment-range__tab-content--display'
          : 'project-sentiment-range__tab-content--hide'
      "
    >
      <ng-template *ngTemplateOutlet="tSentimentScale; context: { scale: 3 }"></ng-template>
    </div>

    <div
      [ngClass]="
        sentimentScale === 5
          ? 'project-sentiment-range__tab-content--display'
          : 'project-sentiment-range__tab-content--hide'
      "
    >
      <ng-template *ngTemplateOutlet="tSentimentScale; context: { scale: 5 }"></ng-template>
    </div>
  </div>

  <ng-template #tSentimentScale let-scale="scale">
    @for (scaleType of scaleTypes; track scaleType) {
      <div class="sentiment-section-header">
        <h3>
          <xi-icon
            [icon]="scaleType.id === 'document' ? 'document_report' : 'chart_filled'"
            iconSize="large"
          ></xi-icon>
          {{ scaleType.label }} {{ t('polarity-ranges') }}
        </h3>
        @if (!readOnly) {
          <div>
            <xi-default-button
              [text]="t('reset-to-defaults')"
              fill="outline"
              (onClick)="resetSlider(scaleType.id)"
            >
            </xi-default-button>
          </div>
        }
      </div>
      @for (item of sentimentRanges[scaleType.id][scale]; track item; let i = $index) {
        <div class="sentiment-slider-row">
          <span class="slider-label">{{ polarities[item.sentimentPolarity] }}</span>
          @switch (i) {
            @case (0) {
              <ngx-slider
                [(value)]="item.max"
                (userChangeEnd)="adjustSiblingSlider($event, scaleType.id, i)"
                [manualRefresh]="slideRefresh"
                [options]="getSliderOptions(scaleType.id, scale, i)"
              ></ngx-slider>
            }
            @case (scale - 1) {
              <ngx-slider
                [(value)]="item.min"
                (userChangeEnd)="adjustSiblingSlider($event, scaleType.id, i)"
                [manualRefresh]="slideRefresh"
                [options]="getSliderOptions(scaleType.id, scale, i)"
              ></ngx-slider>
            }
            @default {
              <ngx-slider
                [(value)]="item.min"
                [(highValue)]="item.max"
                (userChangeEnd)="adjustSiblingSlider($event, scaleType.id, i)"
                [manualRefresh]="slideRefresh"
                [options]="getSliderOptions(scaleType.id, scale, i)"
              ></ngx-slider>
            }
          }
          <app-sentiment-display
            sentimentDisplay="polarity"
            [sentimentScale]="scale"
            [sentimentRanges]="itemsForDisplay[scaleType.id][scale]"
            [item]="itemsForDisplay[scaleType.id][scale][i]"
            [precision]="2"
            [showTooltip]="false"
          ></app-sentiment-display>
        </div>
      }
    }
  </ng-template>

  @if (embeddedButtons) {
    <div class="project-sentiment-range__actions">
      <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>
      <xi-default-button
        [text]="readOnly ? t('close') : t('apply')"
        [disabled]="!hasChanges"
        (onClick)="save()"
      ></xi-default-button>
    </div>
  }
</div>
